export function formatPrice(amount) {
  return `NT$ ${Number(amount).toLocaleString("zh-TW")}`;
}

export function getDisplayPrice(product) {
  return product.salePrice !== null ? product.salePrice : product.price;
}

export function getDiscountPercent(product) {
  if (!product.salePrice) return null;
  return Math.round((1 - product.salePrice / product.price) * 100);
}
